import { TimetableDto } from "@api";
import { enumToWeekday } from "../enum-to-weekday";

export const sortByWeekday = (a: TimetableDto, b: TimetableDto): number => enumToWeekday(a?.weekday) - enumToWeekday(b?.weekday);
